import "core-js/modules/es.array.push.js";
import OrderSummary from './../shared/order-summary.vue';
import CartItem from '../shared/cart-item.vue';
import AddressBox from '../shared/address-box.vue';
import CartAlertBox from '../shared/cart-alert-box.vue';
import { Tooltip } from '../../blocks/output-elements/tooltip';
export default {
  name: 'PopulatedCart',
  emits: ["show-remove-item-modal"],
  props: ['cartData', 'apiCallFailure'],
  components: {
    OrderSummary,
    AddressBox,
    CartAlertBox,
    CartItem,
    Tooltip
  },
  data() {
    return {
      cartEntries: this.cartData?.cartData.entries,
      isMultiPO: this.cartData?.cartData.isMultiPO,
      cartItemLimit: 25,
      isEmptyCartError: false,
      originalPONumber: this.cartData?.cartData?.poNumberForOrder,
      isSaveFailure: false
    };
  },
  created() {
    this.populateItemPOs();
  },
  watch: {
    cartData: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.cartData && newVal.cartData.entries) {
          this.cartEntries = newVal.cartData.entries;
          this.cartEntries.forEach(entry => {
            entry.poNumber = entry.lineItemPO;
          });
          this.isMultiPO = newVal.cartData.isMultiPO;
        }
      }
    }
  },
  methods: {
    getI18nMessage: function (key) {
      return window.Granite.I18n.get(key);
    },
    emitRemoveItemModal(item) {
      this.$emit('show-remove-item-modal', {
        item,
        showModal: true
      });
    },
    emptyCartFailure() {
      this.isEmptyCartError = true;
    },
    saveFailure(state) {
      this.isSaveFailure = state;
    },
    isCheckoutDisabled() {
      return this.cartData?.cartData?.unConfiguredEntries?.length > 0 || this.cartData?.cartData?.needRemoveEntries?.length > 0 || this.cartData?.cartData?.needEditEntries?.length > 0 || this.cartEntries?.length > this.cartItemLimit;
    },
    isUnconfiguredEntry(cartEntry) {
      let unconfiguredEntries = this.cartData?.cartData.unConfiguredEntries;
      return unconfiguredEntries && unconfiguredEntries.find(entry => entry.sapLineItemNumber == cartEntry.sapLineItemNumber) ? true : false;
    },
    isNeedRemoveEntry(cartEntry) {
      let needRemoveEntries = this.cartData?.cartData.needRemoveEntries;
      return needRemoveEntries && needRemoveEntries.find(entry => entry.sapLineItemNumber == cartEntry.sapLineItemNumber) ? true : false;
    },
    isNeedEditEntry(cartEntry) {
      let needEditEntries = this.cartData?.cartData.needEditEntries;
      return needEditEntries && needEditEntries.find(entry => entry.sapLineItemNumber == cartEntry.sapLineItemNumber) ? true : false;
    },
    getPONum() {
      let entriesWithPONum = this.cartEntries?.filter(entry => entry.lineItemPO);
      return entriesWithPONum?.length > 0 && entriesWithPONum.every(entry => entry.lineItemPO === entriesWithPONum[0].lineItemPO) ? entriesWithPONum[0].lineItemPO : '';
    },
    populateItemPOs() {
      if (this.hasHeaderPOValue) {
        let entries = [];
        this.cartEntries.forEach(entry => {
          if (entry.poNumber === "" || entry.poNumber === undefined) {
            entry.poNumber = this.cartData.cartData.poNumberForOrder;
            entries.push(entry.sapLineItemNumber);
          }
        });
        if (entries.length > 0) {
          this.updatePONumber(false, entries);
        }
      }
    },
    resetItemValidity() {
      this.cartEntries.forEach(entry => {
        if (entry.poNumber === "" || entry.poNumber === undefined) {
          entry.isPoInvalid = false;
        }
      });
    },
    updateHeaderPO() {
      this.resetItemValidity();
      if (this.hasHeaderPOValue) {
        let entries = this.cartEntries.map(entry => entry.sapLineItemNumber);
        this.updatePONumber(true, entries);
      } else if (this.cartData.cartData?.poNumberForOrder === "") {
        this.updatePONumber(true, []);
      }
    },
    updatePONumber(hasPurchaseOrderNumberUpdated, entries) {
      let self = this;
      let payload = {
        "hasPurchaseOrderNumberUpdated": hasPurchaseOrderNumberUpdated,
        "purchaseOrderNumberValue": self.cartData.cartData.poNumberForOrder,
        "sapLineItemNumbers": entries
      };
      this.saveFailure(false);
      this.$store.dispatch('cart/updatePONumber', payload).then(data => {
        self.originalPONumber = data.cartData?.poNumberForOrder; // update to new value
        self.updateCartData(data);
      }).catch(error => {
        console.log("Error", error);
        this.saveFailure(true);
      });
    },
    updateCartData(data) {
      this.$emit("cartDataUpdated", data);
    },
    validateItems() {
      this.cartEntries.forEach(entry => {
        entry.isPoInvalid = false;
        this.validateItem(entry);
      });
    },
    validateItem(item) {
      item.isPoInvalid = item.poNumber === "" || item.poNumber === undefined || item.poNumber.length > 35;
    }
  },
  computed: {
    hasForwardingAgent() {
      return this.cartEntries && this.cartEntries.some(entry => entry.forwardingAgent);
    },
    poError() {
      return this.cartEntries.filter(entry => {
        return entry.isPoInvalid;
      }).length > 0;
    },
    isHeaderPODisabled() {
      return this.cartEntries.filter(entry => {
        return entry.poNumber != "" && entry.poNumber != undefined;
      }).length > 0;
    },
    hasHeaderPOValue() {
      return this.cartData.cartData?.poNumberForOrder != undefined && this.cartData.cartData?.poNumberForOrder != "";
    }
  }
};